import axios from "axios";
import { CURRENCY_RATES_ENDPOINTS } from "./currencyRatesConstants";

/**
 * Fetches every configured direction, active or not, newest change first.
 * @returns {Promise<Array>} list of CurrencyRate dicts
 */
export async function fetchCurrencyRates() {
    const { data } = await axios.get(CURRENCY_RATES_ENDPOINTS.list);
    return data;
}

/**
 * Creates one directional rate. The API answers 409 when the pair exists.
 * @param {Object} payload - base_currency, quote_currency, rate, margin_percent
 * @returns {Promise<Object>} the created row
 */
export async function createCurrencyRate(payload) {
    const { data } = await axios.post(CURRENCY_RATES_ENDPOINTS.create, payload);
    return data;
}

/**
 * Updates one direction. Only rate, margin_percent and active can change.
 * @param {number} rateId - identifier of the row to update
 * @param {Object} payload - subset of rate, margin_percent, active
 * @returns {Promise<Object>} the updated row
 */
export async function updateCurrencyRate(rateId, payload) {
    const { data } = await axios.put(CURRENCY_RATES_ENDPOINTS.update(rateId), payload);
    return data;
}
